import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'Applications for Permanent Resident Status',
      icon: '🏠',
      description: 'Comprehensive support for permanent residency applications.',
      features: [
        'Family Sponsorship (spouses, partners, parents, grandparents or dependent children)',
        'Humanitarian and Compassionate Considerations',
        'Express Entry (Canadian Experience Class, Federal Skilled Worker Program and Federal Skilled Trades Program)',
        'Atlantic Immigration Program',
        'Provincial Nominee Program'
      ]
    },
    {
      id: 2,
      title: 'Applications for Temporary Resident Status',
      icon: '📋',
      description: 'Assistance with temporary resident applications and extensions.',
      features: [
        'Visitor\'s Visas',
        'Work Permits (LMIA-exempt work permits, LMIA-supported work permits, post graduate work permits and open work permits)',
        'Study Permits',
        'Applications to Extend your stay in Canada (visitor, worker or student)'
      ]
    },
    {
      id: 3,
      title: 'Other Services',
      icon: '🔧',
      description: 'Additional immigration support and specialized services.',
      features: [
        'Assistance with refusal reviews',
        'Reconsideration requests',
        'Procedural fairness letters',
        'Canadian Citizenship',
        'Permanent Resident Card Renewals'
      ]
    }
  ];

  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1 className="services-title">Immigration Services with Lisa Halliwell, RCIC</h1>
          <p className="services-subtitle">Professional immigration solutions from Canadian Umbrella Immigration Services, Charlottetown, PE</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card-detailed">
                <div className="service-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"/>
                    </svg>
                  </div>
                  <h3>{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <div className="service-features">
                  <h4>Services Include:</h4>
                  <ul>
                    {service.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <Link to="/book-consultation" className="service-cta">
                  Get Started
                </Link>
              </div>
            ))}
          </div>
          
          {/* Common Description */}
          <div className="services-description">
            <p>
              For every service, we'll assess your eligibility, guide you through the documentation requirements, 
              and create a personalized checklist. We offer flexible service options to suit different budgets — 
              from checklist preparation and application review before submission, to full application preparation 
              and submission support.
            </p>
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Immigration Journey?</h2>
            <p>Book a consultation with Lisa Halliwell, RCIC at Canadian Umbrella Immigration Services to discuss your options and begin your immigration process.</p>
            <Link to="/book-consultation" className="btn btn-primary btn-large">
              Book Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 